export default function (value, round = 2) {
  return Math.round(Math.pow(10, round) * value) / Math.pow(10, round)
}
